@import "../../variables.scss";

.wellDone__image {
  position: absolute;
  left: 40px;
  bottom: -419px;
  @media (max-width: 1200px) {
    bottom: -418px;
  }

  @media (max-width: 991px) {
    width: 74%;
    bottom: auto;
    top: 170px;
  }

  @media (max-width: 575px) {
    width: calc(100% + 4rem);
    bottom: auto;
    top: 110%;
    left: -20px;
  }
}

.wellDone__imageBackground {
  position: relative;
  @media (max-width: 991px) {
    margin-bottom: 30px;
  }
}

.wellDone_imageBackground:after {
  content: "";
  width: 852px;
  height: 1071px;
  background-color: $color-background-blue;
  position: absolute;
  left: 8%;
  top: -106%;
  border-radius: 50%;
  transform: rotate(45deg);

  @media (max-width: 991px) {
    left: -52%;
    top: -131%;
    width: 188%;
    height: 171%;
    transform: none;
  }

  @media (max-width: 575px) {
    left: -52%;
    top: -64%;
  }
}

.wellDone__btnContainer {
  position: absolute;
  right: 3rem;
  bottom: 2rem;
}
.wellDone__container {
  height: 580px;
  @media (max-width: 575px) {
    height: 540px;
  }
}
